import { db } from '../firebaseConfig';
import { doc, deleteDoc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';

// Función para eliminar un usuario (requiere Cloud Functions)
export const deleteUser = async (uid: string): Promise<{ success: boolean; message: string }> => {
  try {
    // 1. Verificar si el usuario existe en Firestore
    const userDoc = await getDoc(doc(db, 'users', uid));
    if (!userDoc.exists()) {
      return { 
        success: false, 
        message: 'El usuario no existe en la base de datos.' 
      };
    }

    // 2. Llamar a la Cloud Function para eliminar el usuario de Firebase Authentication
    // Esta función debe estar implementada en Firebase Functions
    const deleteUserAuth = httpsCallable(functions, 'deleteUser');
    const result = await deleteUserAuth({ uid });
    
    // 3. Si la eliminación de Authentication fue exitosa, eliminar el documento de Firestore
    if (result.data && (result.data as any).success) {
      await deleteDoc(doc(db, 'users', uid));
      return { 
        success: true, 
        message: 'Usuario eliminado correctamente.' 
      };
    } else {
      return { 
        success: false, 
        message: (result.data as any).message || 'Error al eliminar el usuario de Authentication.' 
      };
    }
  } catch (error) {
    console.error('Error al eliminar usuario:', error);
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Error desconocido al eliminar el usuario.' 
    };
  }
};

// Función alternativa que solo elimina el documento de Firestore (para pruebas sin Cloud Functions)
export const deleteUserDocument = async (uid: string): Promise<{ success: boolean; message: string }> => {
  try {
    // Verificar si el usuario existe en Firestore
    const userDoc = await getDoc(doc(db, 'users', uid));
    if (!userDoc.exists()) {
      return { 
        success: false, 
        message: 'El usuario no existe en la base de datos.' 
      };
    }

    // Eliminar el documento de Firestore
    await deleteDoc(doc(db, 'users', uid));
    return { 
      success: true, 
      message: 'Documento de usuario eliminado correctamente. NOTA: El usuario aún existe en Authentication y podrá volver a iniciar sesión.' 
    };
  } catch (error) {
    console.error('Error al eliminar documento de usuario:', error);
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Error desconocido al eliminar el documento de usuario.' 
    };
  }
};
